


































































import Vue from 'vue'
import { UserServiceProxy } from '@/service-proxies/app-v2/user.service-proxies'

const userServiceProxy = new UserServiceProxy()

export default Vue.extend({
  name: 'UpdatePwdDialog',
  props: {
    visible: { // 是否展示
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      confirmDirty: false,
      loading: false
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        // 关闭弹框后清空数据
        setTimeout(() => {
          this.form = this.$form.createForm(this)
          this.confirmDirty = false
        }, 500)
      }
    }
  },
  methods: {
    handleConfirmBlur(e: any) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    validateToNextPassword(rule: any, value: any, callback: any) {
      const form = this.form
      let regex1 = new RegExp('(?=.*[0-9])(?=.*[A-Z]).{8,30}')
      let regex2 = new RegExp('(?=.*[0-9])(?=.*[a-z]).{8,30}')
      let regex3 = new RegExp('(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,30}')
      let regex4 = new RegExp('(?=.*[A-Z])(?=.*[a-z]).{8,30}')
      let regex5 = new RegExp('(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,30}')
      let regex6 = new RegExp('(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}')
      if (!value) {
        callback()
      }
      if (value.length < 8 || value.length > 16) {
        callback(this.$t('page_personal_login_password_tip2'))
      } else if (
        !regex1.test(value) &&
        !regex2.test(value) &&
        !regex3.test(value) &&
        !regex4.test(value) &&
        !regex5.test(value) &&
        !regex6.test(value)
      ) {
        callback(this.$t('page_personal_login_password_tip3'))
      }
      if (value && this.confirmDirty) {
        form.validateFields(['newPassword1'], { force: true })
      }
      callback()
    },
    compareToFirstPassword(rule: any, value: any, callback: any) {
      const form = this.form
      if (value && value !== form.getFieldValue('newPassword')) {
        callback(this.$t('page_personal_login_password_tip4'))
      } else {
        callback()
      }
    },
    handleOk() {
      this.loading = true
      const formValues = this.form.getFieldsValue()
      for (let key in formValues) {
        if (!formValues[key]&&key!=='newPassword1') {
          this.form.validateFields([key], {force: true})
        }
      }
      this.form.validateFieldsAndScroll((err: any, values: any) => {
        if (err) {
          this.loading = false
          return
        }
        let { oldPassword, newPassword, newPassword1 } = values
        userServiceProxy.updatePassword(newPassword, newPassword1, oldPassword).then((res: any) => {
          if (res) {
            this.$message.success(res.msg)
            this.$emit('close')
          }
        }).finally(()=>{
          this.loading = false
        })
      })
    },
    handleCancel() {
      this.$emit('close')
    }
  }
})
